/**
 * Aplica o tema salvo antes da pintura da página, para não piscar o tema padrão. Fica num arquivo porque a CSP da
 * página não aceita script inline. Também marca o `<html>` com a classe `js`: o CSS da página pode esconder, já na
 * primeira pintura, o que só o JavaScript sabe mostrar (a tela de login exibe uma visão por vez).
 */
(function () {
    document.documentElement.classList.add("js");
    try {
        var theme = localStorage.getItem("lvx-theme");
        if (theme === "claro" || theme === "escuro") {
            document.documentElement.setAttribute("data-theme", theme);
        }
    } catch (e) {
        /**
         * Sem acesso ao localStorage (modo privado, bloqueio): fica o tema padrão.
         */
    }
})();
